// extracted by css-extract-rspack-plugin
export default {"anchored":"anchored-TrmjtN","root":"root-TUTRE9","title":"title-CivIpx","link":"link-BDHtTR","show":"show-h0yP_t"};